import * as React from 'react';

export type HighPriorityBlocks = ReadonlySet<BlockId>;

export type BlockId = string;

const HighPriorityBlocksContext = React.createContext<HighPriorityBlocks>(new Set());

export const HighPriorityBlocksProvider = HighPriorityBlocksContext.Provider;

export const useIsHighPriorityBlock = (blockId: null | BlockId): boolean => {
	const highPriorityBlocks = React.useContext(HighPriorityBlocksContext);
	return blockId === null || highPriorityBlocks.has(blockId);
};
